import React from 'react';
import '../../styles/styles.css';


export default function dharmastala() {
  return (
    <div className="container mt-4">
        <div className="row">
           
            <div className="col-md-4 box1">
            <img src="/images/Dharmasthala.jpg" alt="Dharmastala Temple" />    
            </div>

            
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Dates<br />
    Navaratri : 22th September, 2025 - 02nd October, 2025<br />    
    <br />

  </strong></p>
  <p>Room Bookings in Dharmasthala : <a href="https://bookings.shridharmasthala.org/online-room-booking" target="_blank" rel="noopener noreferrer">
  Shridharmasthala Temple Website
</a>
  </p>
 </div>
            </div>
        </div>

        
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Dharmasthala Temple, devoted to the Hindu god Manjunatha. Some other temples and shrines are dedicated to Ammanavaru, Chandranath and the Dharma Daivas (guardian spirits of Dharma) — Kalarahu, Kalarkayi, Kumaraswamy and Kanyakumari. The river that flows near Dharmasthala is the Netravati River. It is considered one of the holy rivers of India and is also known as Netravathi Nadi.</p>
           </div>
        </div>

{/* YouTube Section */}
      <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Dharmastala Temple Kitchen</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/iqeTx7700k8?rel=0&modestbranding=1&showinfo=0"
                title="Dharmastala Temple Kitchen"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

    </div>


  )
}
